import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { MudPanel } from "./MudPanel";
import { MudFullJob } from "./MudFullJob";

/**
 * Mud & fluids screen — the standalone route. Resolves the current well's
 * active event and renders its mud product inventory + transaction trend
 * (served by Oxbo-P via /events/{id}/mud-checks).
 */
export function Mud() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();
  return (
    <div>
      <div className="page-head">
        <h1>{t("mud.title")}</h1>
        <p className="subtitle">
          {well ? `${well.commonName} · ${well.field}` : t("well.notSelected")}
        </p>
      </div>
      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {well?.uwi ? <MudFullJob wellUwi={well.uwi} /> : null}
        {activeEvent ? <MudPanel eventId={activeEvent.id} /> : null}
      </QueryState>
    </div>
  );
}
